import '../../style.css';
import React, { FC, useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { useNavigate } from "react-router-dom";
import TeacherLoginForm from "./TeacherLoginForm";
import { ITeacher } from "../models/ITeacher";
import Spinner from "../../UI/Spinner/Spinner";
import useIsMobile from "../../utils/useIsMobile";
import { motion } from 'framer-motion';


const TeacherLoginPage: FC = () => {
    const { teacherstore } = useContext(Context);
    const navigate = useNavigate();

    const [teachers, setTeachers] = useState<ITeacher[]>([]);
    const [showContent, setShowContent] = useState<boolean>(teacherstore.teacher.isActivated);

    const isMobile = useIsMobile();

    // Update showContent when teacher activation status changes
    useEffect(() => {
        setShowContent(teacherstore.teacher.isActivated);
    }, [teacherstore.teacher.isActivated]);

    useEffect(() => {
        if (teacherstore.isAuthT) {
            // Create named handler so it can be properly removed
            const handleActivity = () => {
                teacherstore.setLastActivityTime(Date.now());
            };

            const timeoutId = setTimeout(() => {
                teacherstore.logoutTeacher()
            }, 3 * 60 * 60 * 1000); // 3 hours

            // Add event listener to reset inactivity timer on button clicks
            window.addEventListener('click', handleActivity);

            return () => {
                window.removeEventListener('click', handleActivity);
                clearTimeout(timeoutId);
            };
        }
    }, [teacherstore.isAuthT]);


    if (teacherstore.isLoading) {
        return <div><Spinner /></div>
    }

    if (!teacherstore.isAuthT) {
        return (
            <div className='jcc center mt-64 mb-32' style={{ maxWidth: 300 }}>
                <TeacherLoginForm />
            </div>
        );
    }


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
        >

            <div style={{ maxWidth: '370px', margin: '0 auto', marginTop: '100px' }}>
                <h2 className='pb-16 center'>Välkommen till Let's roll</h2>
                <h5 className='center pt-32'> {teacherstore.isAuthT ? `Inloggad som ${teacherstore.teacher.email}` : 'Please log in'}</h5>
                <h4 className='center pt-32'> Handledare </h4>
                <div className='center pt-32 mb-16'>
                    {teacherstore.teacher.isActivated ? (
                        <div>
                            <span>
                                <button onClick={() => navigate("/instructornotes")} className={'buttonM'} >Övningskörningskort</button>
                            </span>

                            <span>
                                <button onClick={() => navigate("/settingsT")} className={'buttonM'} >Inställningar</button>
                            </span>
                        </div>
                    ) : (

                        <p style={{ fontSize: "1.5rem" }}>Vänligen aktivera ditt konto (aktiverings e-mail finns i din brevlåda)</p>
                    )}
                </div>

                <div className='center'>

                    <button className={"buttonM mt-64 center"} onClick={() => teacherstore.logoutTeacher()}>Log out</button>

                </div>
            </div>
        </motion.div>


    );
};

export default observer(TeacherLoginPage);